import { toast } from "sonner";
import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import DemoNote from "@/components/DemoNote";
import CTABand from "@/components/CTABand";
import usePageMeta from "@/hooks/usePageMeta";
import { NEWS } from "@/config/company";
import { ArrowUpRight } from "lucide-react";

export default function News() {
  usePageMeta(
    "News — MMC S.r.l. | Carpenteria Metallica",
    "Novità, promozioni e aggiornamenti aziendali di MMC S.r.l., azienda di carpenteria metallica."
  );

  const openArticle = (n) => {
    toast.info("Articolo completo in arrivo", {
      description: `${n.title} — presto disponibile in questa pagina.`,
    });
  };

  return (
    <main>
      <PageHeader
        index="05"
        eyebrow="Aggiornamenti"
        title="News"
        sub="Novità, promozioni e aggiornamenti dall'officina: cosa succede in MMC S.r.l."
      />

      <section data-testid="news-list" className="px-5 py-16 md:px-10 md:py-24 lg:px-16">
        <div className="mx-auto max-w-5xl">
          <div className="border-t border-white/10">
            {NEWS.map((n, i) => (
              <Reveal key={n.id} delay={i * 0.05}>
                <article
                  data-testid={`news-card-${n.id}`}
                  className="group grid gap-4 border-b border-white/10 py-10 transition-colors duration-300 hover:bg-white/[0.02] md:grid-cols-12 md:items-baseline md:gap-6 md:py-14"
                >
                  <div className="md:col-span-3">
                    <p className="font-tech text-[10px] uppercase tracking-[0.25em] text-molten">{n.cat}</p>
                    <p className="mt-2 font-tech text-[10px] uppercase tracking-[0.25em] text-white/40">{n.date}</p>
                  </div>
                  <div className="md:col-span-8">
                    <h2 className="font-display text-2xl font-semibold uppercase leading-snug tracking-tight transition-colors duration-300 group-hover:text-molten sm:text-3xl">
                      {n.title}
                    </h2>
                    <p className="mt-4 max-w-2xl leading-relaxed text-fog">{n.excerpt}</p>
                  </div>
                  <div className="md:col-span-1 md:text-right">
                    <button
                      data-testid={`news-read-btn-${n.id}`}
                      onClick={() => openArticle(n)}
                      aria-label={`Leggi: ${n.title}`}
                      className="inline-flex size-11 items-center justify-center border border-white/15 text-white/70 transition-colors duration-300 hover:border-molten hover:text-molten"
                    >
                      <ArrowUpRight className="size-4" />
                    </button>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
          <DemoNote className="mt-10" />
        </div>
      </section>

      <CTABand />
    </main>
  );
}
